
import { IGroupWithIds } from "@app/main/components/resourceManagement/groups/_models/IGroupWithIds";
import { DateService } from "@app/services/date.service";
import { UnitStatus } from "@enums/UnitStatus";
import { IVehicle } from "@interfaces/IVehicle";
import { ConstantsService } from "@services/constantsService";
import { MapService } from "@services/map.service";
import { SessionService } from "@services/session.service";
import { TranslationService } from "@services/translation.service";
import { VehicleService } from "@services/vehicle.service";
import * as angular from "angular";
import { copy } from "angular";
import "./vehicleList.scss";

export interface IViewOptions {

    orderBy: LiveMapOrderByOptions;
    groupBy: string;
    //viewBy: string;
    reverse: boolean;

    orderByOptions: { name: string, value: LiveMapOrderByOptions }[];
}

export class LiveMapOrderByOptions {

    // ReSharper disable InconsistentNaming

    static get ID(): string { return "ID"; }
    static get Reg(): string { return "Reg"; }
    static get DriverName(): string { return "Driver.Name"; }
    static get Make(): string { return "Make"; }
    static get Speed(): string { return "-Plot.Velocity"; }
    static get Distance(): string { return "Distance"; }
    static get LastUpdated(): string { return "-Plot.Utc"; }

    // ReSharper restore InconsistentNaming
}

interface IVehicleListBindings {
    vehicles: IVehicle[];
    selectedVehicle: IVehicle;
    nearestToCenter: any; // this is any rather than google.maps.latlng to prevent runtime errors
    loading: boolean;

    hideSort: boolean;

    vehiclesFiltered: (vehicles: { $vehicles: IVehicle[] }) => void;
    vehicleClicked: (vehicle: { $vehicle: IVehicle }) => void;
    vehicleOrderbyChanged: (sort: { $orderBy: LiveMapOrderByOptions }) => void;
}

interface IVehicleListFilterOptions {
    vehicleWildcard?: string;
    group?: IGroupWithIds;
}

class VehicleListComponentController implements angular.IComponentController, IVehicleListBindings {

    loadedVehicles = false;
    loading: boolean;

    vehicles: IVehicle[];
    selectedVehicle: IVehicle;
    nearestToCenter: google.maps.LatLng;

    hideSort: boolean;

    vehiclesDisplay: IVehicle[];

    filter: IVehicleListFilterOptions;
    showVehicleSortOptions = false;
    viewOptions: IViewOptions;
    showMilesAway = false;
    //vehicleGroups: IGroup[];

    selectedVehicleIndex = 0;
    unitStatus = UnitStatus;

    dontScrollListOnNextUpdate = false;

    vehicleClicked: (vehicle: { $vehicle: IVehicle }) => void;
    vehicleDoubleClicked: (vehicle: { $vehicle: IVehicle }) => void;
    vehiclesFiltered: (vehicles: { $vehicles: IVehicle[] }) => void;
    vehicleOrderbyChanged: (sort: { $orderBy: LiveMapOrderByOptions }) => void;

    vehicleClickTimeout: angular.IPromise<any>;
    isMobile: boolean;

    static $inject = ["$scope", "$timeout", "$filter", "dateService", "sessionService", "vehicleService", "mapService", "constantsService", "translationService"];

    constructor(
        private readonly $scope: angular.IScope,
        private readonly $timeout: angular.ITimeoutService,
        private readonly $filter: angular.IFilterService,
        private readonly dateService: DateService,
        private readonly sessionService: SessionService,
        private readonly vehicleService: VehicleService,
        private readonly mapService: MapService,
        private readonly constantsService: ConstantsService,
        private readonly translationService: TranslationService) {

        this.isMobile = this.constantsService.getIsMobile();

        this.filter = {
            vehicleWildcard: ""
        };

        this.viewOptions = {
            orderBy: LiveMapOrderByOptions.Reg,
            groupBy: "",
            reverse: false,
            orderByOptions: []
        };

        this.viewOptions.orderByOptions.push({ name: this.translationService.t("vehicleList.orderByOptions.reg"), value: LiveMapOrderByOptions.Reg });
        this.viewOptions.orderByOptions.push({ name: this.translationService.t("vehicleList.orderByOptions.driverName"), value: LiveMapOrderByOptions.DriverName });
        //optionsList.push(new LiveMap.Model.OrderByOptionsModel("Make", LiveMapOrderByOptions.Make));
        this.viewOptions.orderByOptions.push({ name: this.translationService.t("vehicleList.orderByOptions.speed"), value: LiveMapOrderByOptions.Speed });
        this.viewOptions.orderByOptions.push({ name: this.translationService.t("vehicleList.orderByOptions.nearestTo"), value: LiveMapOrderByOptions.Distance });
        this.viewOptions.orderByOptions.push({ name: this.translationService.t("vehicleList.orderByOptions.lastUpdated"), value: LiveMapOrderByOptions.LastUpdated });

    }

    $onInit(): void {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        //(this.$scope as any).$suspend();

        if (onChangesObj["vehicles"]) {
            if (this.vehicles != null) {
                this.loadedVehicles = true;
                this.filterDisplayVehicles();

                if (/*this.vehicles.length > 0 ||*/ !onChangesObj["vehicles"].isFirstChange()) {
                    //if (this.vehicles != null && this.vehicles.length !== 0) {
                    //this.populateVehicleGroups();
                    //}
                }
            }
        }

        if (onChangesObj["selectedVehicle"] && !onChangesObj["selectedVehicle"].isFirstChange()) {

            if (!this.dontScrollListOnNextUpdate) {
                const previousValue = onChangesObj["selectedVehicle"].previousValue as IVehicle;
                const currentValue = onChangesObj["selectedVehicle"].currentValue as IVehicle;

                if (previousValue == null || currentValue == null || (previousValue.Id !== currentValue.Id)) {
                    this.selectedVehicleIndex = this.vehiclesDisplay.indexOf(this.selectedVehicle);
                }
            }

            this.dontScrollListOnNextUpdate = false;
        }

        if (onChangesObj["nearestToCenter"] && !onChangesObj["nearestToCenter"].isFirstChange()) {
            this.calculateVehicleDistancesFromPoint();
        }
    }

    orderByChanged(): void {
        this.calculateVehicleDistancesFromPoint();
        this.sortDisplayVehicles();

        this.showMilesAway = (this.viewOptions.orderBy === LiveMapOrderByOptions.Distance);

        if (this.vehicleOrderbyChanged) {
            this.vehicleOrderbyChanged({ $orderBy: this.viewOptions.orderBy });
        }
    }

    toggleVehicleSortOptionsVisibility() {
        this.showVehicleSortOptions = !this.showVehicleSortOptions;
    }

    onGroupClicked(group: IGroupWithIds) {
        this.filter.group = group;
        this.filterDisplayVehicles();
    }

    onVehicleClicked(vehicle: IVehicle) {

        // Double click behaviour
        if (this.vehicleClickTimeout) {

            this.$timeout.cancel(this.vehicleClickTimeout);
            this.vehicleClickTimeout = null;

            if (this.vehicleDoubleClicked !== null) {
                this.dontScrollListOnNextUpdate = true;

                this.vehicleDoubleClicked({ $vehicle: vehicle });
            }

            return;
        }

        // Single click behaviour

        this.vehicleClickTimeout = this.$timeout(() => {
            if (this.vehicleClicked !== null) {
                this.dontScrollListOnNextUpdate = true;

                this.vehicleClicked({ $vehicle: vehicle });
                this.vehicleClickTimeout = null;
            }
        }, 250);
    }

    filterDisplayVehicles() {
        if (this.vehicles == null) {
            return;
        }

        this.vehiclesDisplay = this.filterVehicleList(this.vehicles, this.filter);
        this.sortDisplayVehicles();

        if (this.vehiclesFiltered != null) {
            this.vehiclesFiltered({ $vehicles: this.vehiclesDisplay });
        }

        this.$scope.$applyAsync();
    }

    // ------------------------------------------------------------------------------

    private sortDisplayVehicles() {
        this.vehiclesDisplay = this.$filter('orderBy')(this.vehiclesDisplay, this.viewOptions.orderBy as string, this.viewOptions.reverse);

        this.sortUpdatedVehicles();

        // Go through each trailer, pop off, then re-insert at correct order below the tractor
        var trailers: IVehicle[] = [];

        this.vehiclesDisplay.forEach(v => {
            if (v.tractor) {
                trailers.push(v);
            }
        });

        trailers.forEach(trailer => {
            var trailerIndex = this.vehiclesDisplay.indexOf(trailer);
            this.vehiclesDisplay.splice(trailerIndex, 1);

            var tractorIndex = 0;
            this.vehiclesDisplay.forEach((v, i) => {
                if (v.Id == trailer.tractor.Id) {
                    tractorIndex = i;
                    trailer.showTrailerHookup = true;

                    const trailerPlotIsLatest = this.dateService.date1IsAfterDate2(trailer.Plot.Utc, trailer.tractor.Plot.Utc);

                    if (trailerPlotIsLatest) {
                        trailer.tractor.Plot = copy(trailer.Plot);
                        v.Plot = copy(trailer.Plot);
                    } else {
                        trailer.Plot = copy(v.Plot);
                        trailer.tractor.Plot = copy(v.Plot);
                    }

                    v.Plot.UtcMoment
                }
            });

            this.vehiclesDisplay.splice(tractorIndex + 1, 0, trailer);
        });
    }

    private sortUpdatedVehicles(): void {
        // Move vehicles that have never updated to the bottom of the list if sorting by descending date
        if (this.viewOptions.orderBy == LiveMapOrderByOptions.LastUpdated) {
            this.vehiclesDisplay = this.vehiclesDisplay.sort((a, b) => {
                if (!a.Plot) {
                    return this.viewOptions.reverse ? -1 : 1;
                }

                if (!b.Plot) {
                    return this.viewOptions.reverse  ? 1 : -1;
                }

                return 0;
            })
        }
    }

    private vehicleMatchesSearchTerm(vehicle: IVehicle, searchTerm: string, preventRecursion = false): boolean {
        if (vehicle.Reg.toLowerCase().indexOf(searchTerm) >= 0 || vehicle.ShortReg.toLowerCase().indexOf(searchTerm) >= 0) {
            return true;
        }
        else if (vehicle.Driver && vehicle.Driver.Name.toLowerCase().indexOf(searchTerm) >= 0) {
            return true;
        }

        if (preventRecursion) {
            return false;
        }

        // We should show parent / child trailer associations also (so we see the complete travelling unit)
        if (vehicle.attachedTrailers) {
            for (var i = 0; i < vehicle.attachedTrailers.length; i++) {
                const trailer = vehicle.attachedTrailers[i];

                if (this.vehicleMatchesSearchTerm(trailer, searchTerm, true)) {
                    return true;
                }
            }
        }

        if (vehicle.tractor) {
            if (this.vehicleMatchesSearchTerm(vehicle.tractor, searchTerm, true)) {
                return true;
            }
        }
    }

    private filterVehicleList(vehicles: IVehicle[], vehicleListFilterOptions: IVehicleListFilterOptions) {

        var filtered: IVehicle[] = [];

        if (!vehicleListFilterOptions || (!vehicleListFilterOptions.group && !vehicleListFilterOptions.vehicleWildcard)) {
            vehicles.forEach(vehicle => {

                if (this.vehicleService.showVehicleWithNoUnit(vehicle) && this.vehicleService.showNonFunctioningUnit(vehicle)) {
                    filtered.push(vehicle);
                }
            });

            return filtered;
        }

        var lowerCaseWildCard = vehicleListFilterOptions.vehicleWildcard ? vehicleListFilterOptions.vehicleWildcard.toLowerCase() : null;

        vehicles.forEach(vehicle => {

            var wildcardHit = false;
            var wildcardRequired = false;

            var groupHit = false;
            var groupRequired = false;

            var isFunctioningUnit = false;

            if (lowerCaseWildCard) {
                wildcardRequired = true;

                wildcardHit = this.vehicleMatchesSearchTerm(vehicle, lowerCaseWildCard);
            }

            if (vehicleListFilterOptions.group) {
                groupRequired = true;

                // See if we are in this group
                if (vehicleListFilterOptions.group.VehicleIds.indexOf(vehicle.Id) >= 0) {
                    groupHit = true;
                }
            }

            if (this.vehicleService.showNonFunctioningUnit(vehicle)) {
                isFunctioningUnit = true;
            }

            if ((!wildcardRequired || wildcardHit) && (!groupRequired || groupHit) && isFunctioningUnit) {
                filtered.push(vehicle);
            }
        });

        filtered.forEach(vehicle => {
            if (vehicle.tractor && !filtered.find(v => v.Id == vehicle.tractor.Id)) {
                vehicle.showTrailerHookup = false;
            }
        })

        return filtered;
    }

    private calculateVehicleDistancesFromPoint() {

        if (this.viewOptions.orderBy !== LiveMapOrderByOptions.Distance || !this.nearestToCenter) {
            return;
        }

        for (let i = 0; i < this.vehiclesDisplay.length; i++) {

            const vehicle = this.vehiclesDisplay[i];

            if (!vehicle.Plot?.markerModel?.options?.visible) {
                continue;
            }

            vehicle.Distance = this.mapService.getDistance(this.nearestToCenter.lat(), this.nearestToCenter.lng(), vehicle.Plot.Latitude, vehicle.Plot.Longitude);
        }

        this.sortDisplayVehicles();
    }
}

export class VehicleListComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            vehicles: "<",
            selectedVehicle: "<",
            nearestToCenter: "<",
            hideSort: "<",
            loading: "<",

            vehicleClicked: "&",
            vehicleDoubleClicked: "&",
            vehicleOrderbyChanged: "&",
            vehiclesFiltered: "&"
        };

        this.controller = VehicleListComponentController;
        this.template = require("./vehicleList.html");
    }
}
